import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteWebhookMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;

export type DeleteWebhookMutation = {
  __typename?: 'Mutation';
  deleteWebhook: boolean;
};

export const DeleteWebhookDocument = gql`
  mutation DeleteWebhook($id: UUID!) {
    deleteWebhook(id: $id)
  }
`;
export type DeleteWebhookMutationFn = Apollo.MutationFunction<
  DeleteWebhookMutation,
  DeleteWebhookMutationVariables
>;

/**
 * __useDeleteWebhookMutation__
 *
 * To run a mutation, you first call `useDeleteWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWebhookMutation, { data, loading, error }] = useDeleteWebhookMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWebhookMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteWebhookMutation,
    DeleteWebhookMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteWebhookMutation,
    DeleteWebhookMutationVariables
  >(DeleteWebhookDocument, options);
}
export type DeleteWebhookMutationHookResult = ReturnType<
  typeof useDeleteWebhookMutation
>;
export type DeleteWebhookMutationResult =
  Apollo.MutationResult<DeleteWebhookMutation>;
export type DeleteWebhookMutationOptions = Apollo.BaseMutationOptions<
  DeleteWebhookMutation,
  DeleteWebhookMutationVariables
>;
